<template>
  <div class="spin-library-playlist-field">
    <p class="field-name">{{ field.name }}</p>
    <base-list-item class="playlist-fields" @click="findMatch">
      <div
        class="field-item"
        v-for="(field, index) in field.fields"
        :key="index"
      >
        <p class="field-item-name">{{ field.inputTitle }}</p>
        <p class="field-item-value">
          {{ field.value ? field.value : "No Input" }}
        </p>
      </div>
    </base-list-item>
    <library-form-match
      v-if="this.field.libraryMatch"
      :track="this.field.libraryMatch"
      @delete-match="deleteMatch"
    />
  </div>
</template>
<script>
import BaseListItem from "../BaseListItem.vue";
import LibraryFormMatch from "./LibraryFormMatch.vue";
// import RoundButtonWithIcon from "../../RoundButtonWithIcon.vue";

export default {
  methods: {
    deleteMatch() {
      this.$emit("delete-match");
    },
    findMatch() {
      this.$emit("find-match");
    },
  },
  components: {
    BaseListItem,
    LibraryFormMatch,
  },
  emits: ["delete-match", "find-match"],
  props: ["field"],
};
</script>
<style scoped>
p {
  font-size: 0.55rem;
  text-align: left;
}

.playlist-fields {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.field-name {
  font-weight: 600;
  margin-bottom: 5px;
}

.field-item {
  width: 33%;
}

.field-item-value {
  margin-left: 10px;
}
</style>
